export default __webpack_public_path__ + "static/media/triste.eff02a2b.png";